function Listbox(params) {
    if (!params.container) {
        return;
    }
    
    this.setDefaults(params);
    this.addListeners();
}

Listbox.prototype.setDefaults = function(params) {
    this.dom = {
        $container: params.container,
        $button: params.container.find(params.buttonClass),
        $list: params.container.find(params.listClass),
        $input: params.container.find(params.inputClass)
    };
    
    this.activeClass = params.activeClass;
    this.hoverClass = params.hoverClass;
    this.focusedClass = params.focusedClass;
    this.disabledClass = params.disabledClass;
    this.selectedItem = this.dom.$list.find('.' + params.activeClass);
    this.keycodes = {
        UP: 38,
        DOWN: 40,
        SPACE: 32,
        RETURN: 13,
        PGUP: 33,
        PGDOWN: 34,
        SHIFT: 16,
        TAB: 9,
        ESC: 27
    };
};

Listbox.prototype.addListeners = function() {
    $(window).on("keyup keydown", this.checkShift.bind(this));
    this.dom.$button.on("click", this.showList.bind(this));
    this.dom.$list.on("blur", this.hideList.bind(this));
    this.dom.$list.on("keydown", this.handleKeyEvent.bind(this));
    this.dom.$list.on("click", this.changeSelection.bind(this));
};

Listbox.prototype.showList = function(e) {
    if(this.dom.$container.hasClass(this.disabledClass)) {
        return;
    }
    
    if(e)
    e.preventDefault();
    
    this.dom.$button.attr("aria-expanded", true);
    
    var item = this.selectedItem.length ? this.selectedItem : this.dom.$list.children().first();
    item.addClass(this.hoverClass);
    this.dom.$list.scrollTop(item[0].offsetTop);
    this.dom.$list.attr('aria-activedescendant', item.attr('id'));
    
    this.dom.$container.addClass(this.focusedClass);
    this.dom.$list.attr('aria-activedescendant', this.selectedItem.attr('id'));
    this.dom.$list.attr("tabindex", -1);
    this.dom.$list.focus();
};

Listbox.prototype.hideList = function(e) {
    if(e)
    e.preventDefault();
    
    this.dom.$container.removeClass(this.focusedClass);
    this.dom.$button.focus().attr("aria-expanded", false);
    this.dom.$list.removeAttr("tabindex");
    
    this.dom.$list.children()
    .not(this.selectedItem)
    .removeClass(this.hoverClass);
    
    if(this.selectedItem.length) {
        this.dom.$list.attr('aria-activedescendant', this.selectedItem.attr('id'));
    } else {
        this.dom.$list.attr('aria-activedescendant', '');
    }
};

Listbox.prototype.changeSelection = function(e) {
    var item = $(e.target);
    item.addClass(this.activeClass).addClass(this.hoverClass);
    item.attr("aria-selected", true);
    item.siblings().removeClass(this.activeClass);
    item.siblings().attr("aria-selected", false);
    
    this.selectedItem = item;
    this.dom.$button.text(item.text()).attr("aria-activedescendant", item.attr('id'));
    this.dom.$list.attr("aria-activedescendant", item.attr('id'));
    this.dom.$input.val(item.data('value')).trigger('change');
    this.hideList();
};

Listbox.prototype.selectNext = function(direction) {
    var item = this.dom.$list.find('.' + this.hoverClass);
    var next = (direction === "up") ?
    item.prev() :
    item.next() ;
    
    if(next.length) {
        next.siblings().removeClass(this.hoverClass);
        next.addClass(this.hoverClass);
        this.dom.$list.scrollTop(next[0].offsetTop);
        this.dom.$list.attr('aria-activedescendant', next.attr('id'));
    }
};

//could be a letter or a boolean
Listbox.prototype.selectSpecific = function(param) {
    var item;
    if (typeof param === "boolean") {
        item = param ? this.dom.$list.children().first() : this.dom.$list.children().last();
        this.currentLetter = null;
    } else {
        item = this.currentLetter === param ? this.dom.$list.find("." + this.hoverClass).nextAll() : this.dom.$list.children();
        item = item.filter(function(i){
            return $(this).text().indexOf(param) === 0;
        }).first();
    }

    if(item.length) {
        item.siblings().removeClass(this.hoverClass);
        item.addClass(this.hoverClass);
        this.dom.$list.scrollTop(item[0].offsetTop);
        this.dom.$list.attr('aria-activedescendant', item.attr('id'));
    }
};

Listbox.prototype.handleKeyEvent = function(e) {
    var key = e.which;
    switch (key) {
        case this.keycodes.UP:
            e.preventDefault();
            this.selectNext("up");
            break;
        case this.keycodes.DOWN:
            e.preventDefault();
            this.selectNext("down");
            break;
        case this.keycodes.PGUP:
        case this.keycodes.PGDOWN:
            e.preventDefault();
            this.selectSpecific(key === this.keycodes.PGUP);
            break;
        case this.keycodes.SPACE:
        case this.keycodes.RETURN:
            e.preventDefault();
            this.dom.$list.find('.' + this.hoverClass).click();
            break;
        case this.keycodes.TAB:
            if(this.shiftIsPressed)
                this.dom.$container.prev().focus();
            break;
        case this.keycodes.ESC:
            this.hideList();
            this.dom.$button.focus().addClass('focus-ring');
            break;
        default: 
            var letter = String.fromCharCode(key);
            if (/[a-zA-Z]/.test(letter)) {
                this.selectSpecific(letter);
                this.currentLetter = letter;
            }
        break;
    }
};

Listbox.prototype.checkShift = function(e) {
    if(e.which == this.keycodes.SHIFT)
    this.shiftIsPressed = e.type === "keydown";
};

(function($) {
    $(".select-wrapper").each(function(i, el) {
    new Listbox({
        container: $(el),
        buttonClass: ".select-button",
        listClass: ".select-listbox",
        inputClass: ".select-input",
        activeClass: "active",
        hoverClass: "hover",
        focusedClass: "focused",
        disabledClass: "disabled"
    });
    });
})(jQuery);
